:host(:not([focused])) {
  // reset any margin or padding (e.g. from stzh-vspace/hspace components)
  // so the host element won't take up any space when link inside is not focuseds
  padding: 0 !important;
  margin: 0 !important;
}

.stzh-skiplink {
  @include visuallyhiddenFocusable;
  display: inline-block;
  right: 0;
  top: 0;
  white-space: nowrap;
  padding: space("large") space("xxlarge");
  border: solid 1px $colorGrey50;
  border-radius: 2px;
  background: $colorWhite;
  color: $colorPrimary;
  transition: color $baseTransitionAnimationSpeed;
  text-decoration-line: none;

  &:hover {
    color: $colorPrimaryHover;
  }
}
